import React from 'react';
import { useLocation } from 'react-router-dom';
import PaymentFlow from './PaymentFlow';
import Payment from './checkout/Payment';
import { readPendingCheckout } from '../utils/razorpayCheckout';

/**
 * Routes B-07P Razorpay flow vs legacy multi-step checkout payment
 */
export default function CheckoutPaymentRoute() {
  const location = useLocation();
  const pending = readPendingCheckout(location.state);
  if (pending?.orderId && pending?.razorpayOrderId) {
    return <PaymentFlow />;
  }
  return <Payment />;
}
